/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserActionSchema = {
    name: UserActionSchema.name;
    value: boolean;
};
export namespace UserActionSchema {
    export enum name {
        EMAIL_VERIFIED = 'EMAIL_VERIFIED',
        DISABLED = 'DISABLED',
    }
}

